import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';

//import components
import ItemText from './ItemText.js';

const ItemInText = ({ clang, list }) => {
    return (
        list.map((listItem, index) =>
            <div key={index} className="item__in-text">
                <label className="item__in-text__label">
                    {lang[clang].item.item_type[listItem.entityType]}
                </label>
                <div className="item__in-text__content">
                    <ItemText
                        text={listItem.label}
                        link={listItem.link}
                        type={listItem.entityType}/>
                </div>
            </div>)
    );
};

ItemInText.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemInText);



// WEBPACK FOOTER //
// ./src/components/items/ItemInText.js